<template>
  <div id="edit-team-link">
    <!-- Edit Logo -->
    <SalesRepsModal
      :modalMode="modalMode"
      :modalName="modalName"
      :modalEmail="modalEmail"
      :modalPhone="modalPhone"
      :modalUserId="modalUserId"
      :showBackdrop="'false'"
      v-on="{ postModal }"
    />
    <div class="edit-team-container">
      <div class="modal-header">
        <h5 class="modal-title">Edit Project Details</h5>
      </div>
      <div class="row edit-team-content">
        <!-- School name, team name -->
        <div class="col-sm-6">
          <div class="wiz-container col">
            <!-- School name -->
            <div class="input-group-column mb-4">
              <label>
                Full School/Team Name:
                <span class="required">*</span>
              </label>
              <input
                @change="reValidateForm()"
                type="text"
                class="form-control"
                :class="{ 'is-invalid': errors.name }"
                placeholder="ie Myers Park High School"
                v-model="name"
              />
              <div class="error invalid-feedback" v-if="errors.name">
                {{ errors.name }}
              </div>
              <span class="form-text text-muted"
                >We will use this as the title of your project.</span
              >
            </div>
            <!-- Team Name -->
            <div class="input-group-column mb-4" v-if="project.team_name">
              <label>
                Team Name or Mascot:
                <span class="required">*</span>
              </label>
              <input
                @change="reValidateForm()"
                type="text"
                class="form-control"
                :class="{ 'is-invalid': errors.mascot }"
                placeholder="ie Mustangs"
                v-model="mascot"
              />
              <div class="error invalid-feedback" v-if="errors.mascot">
                {{ errors.mascot }}
              </div>
              <span class="form-text text-muted"
                >We will use this as the Name on the Team Jerseys.</span
              >
            </div>
          </div>
        </div>

        <!-- Reps Column -->
        <div class="col-sm-6 wiz-last-col">
          <div class="wiz-container row">
            <div class="form-group margin-0">
              <label> Select a sales rep</label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text" id="sales-rep-spn">
                    <i class="la la-user"></i>
                  </span>
                </div>
                <div class="d-flex align-items-center flex-fill">
                  <v-select
                    class="flex-fill mr-3"
                    v-model="selected_rep_id"
                    :options="dealer.reps"
                    :reduce="(rep) => rep.id"
                    placeholder="Select a sales rep"
                    label="name"
                  >
                  </v-select>
                  <button
                    type="button"
                    class="btn btn-brand"
                    data-toggle="modal"
                    data-target="#add_sales_rep_modal"
                    @click="openCreateSalesRepModal(0)"
                  >
                    + ADD NEW
                  </button>
                </div>
              </div>
              <span class="form-text text-muted">
                Assign a rep to this project. Their information will display on
                the header, and all messages and quotes will go to their
                email.</span
              >
              <div
                class="rep-information"
                v-if="Object.keys(selected_rep).length"
              >
                <h4 class="rep-title">
                  {{ selected_rep.name }}
                </h4>
                <p>{{ selected_rep.email }}</p>
                <p>{{ selected_rep.phone }}</p>
              </div>
            </div>
          </div>
          <div id="override-pricing" class="row" v-if="!tempHide">
            <div class="form-group col margin-0 override-check-container">
              <label for="override-check">Override Pricing Options</label>
              <div class="kt-checkbox-inline">
                <input
                  type="checkbox"
                  v-model="overridePricing"
                  id="override-check"
                />
              </div>
            </div>
            <div id="override-pricing-fields" v-if="overridePricing">
              <div class="row">
                <div class="col form-group switch-group">
                  <label class="col">Display MSRP Pricing</label>
                  <span class="kt-switch kt-switch--icon">
                    <label class="col-form-label">
                      <input
                        type="checkbox"
                        checked="checked"
                        v-model="display_msrp"
                      />
                      <span></span>
                    </label>
                  </span>
                </div>
                <div class="col form-group">
                  <label for="comp_msg_select">Complimentary Message</label>
                  <select
                    class="form-control full-width"
                    id="comp_msg_select"
                    v-model="complimentary_msg"
                  >
                    <option value="1">Call for Final Pricing</option>
                    <option value="2">Team discounts available</option>
                    <option value="3">Lowest prices guaranteed!</option>
                    <option value="0">[BLANK]</option>
                  </select>
                  <small>Add details about pricing for users</small>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Buttons -->
        <div class="row wiz-submit-container">
          <button
            v-if="!loading"
            type="button"
            class="btn btn-outline-brand btn-tall"
            @click="cancel()"
          >
            CANCEL
          </button>
          <button
            v-if="!loading"
            type="button"
            class="btn btn-brand btn-tall"
            @click="save()"
          >
            SAVE CHANGES
          </button>
          <button
            v-if="loading"
            type="button"
            class="btn btn-secondary btn-tall"
          >
            Loading
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapState, mapActions } from "vuex";

import SalesRepsModal from "@/components/Dashboard/SalesReps/SalesRepsModal.vue";

export default {
  name: "EditProject",
  components: {
    SalesRepsModal,
  },
  props: [
    "project",
    "projectTypeToBeEdited",
    "editName",
    "editMascot",
    "editSelectedRepId",
    "editSelectedRep",
    "editOverridePricing",
    "editDisplayMSRP",
    "editComplimentaryMsg",
    "editId",
  ],

  data() {
    return {
      errors: [],
      tempHide: true,
      loading: false,
      projectId: this.project.id,
      name: this.project.title,
      mascot: this.project.team_name,
      selected_rep_id: this.project.rep_id,
      overridePricing: false,
      display_msrp: 1,
      complimentary_msg: 1,

      createMode: false,

      editableLogo: {},

      //Sales Rep modal
      modalMode: 0,
      modalName: "",
      modalEmail: "",
      modalPhone: "",
      modalUserId: 0,
    };
  },

  computed: {
    ...mapState(["auth", "dealer"]),

    selected_rep() {
      let rep = {};
      for (let index = 0; index < this.dealer.reps.length; index++) {
        if (this.dealer.reps[index].id === this.selected_rep_id) {
          rep = this.dealer.reps[index];
        }
      }
      return rep;
    },
  },

  methods: {
    ...mapActions("dealer", [
      "addNewSalesRep",
      "editSalesRep",
      "removeSalesRep",
    ]),
    cancel() {
      this.$emit("editEvent", "cancel");
    },
    reValidateForm() {
      if (this.has_errors) {
        this.checkForm(false);
      }
    },
    checkForm: function (withToast = true) {
      this.errors = {};

      if (!this.name.length) {
        this.errors.name = "Name is required.";
      }
      if (this.project.team_name && !this.mascot.length) {
        this.errors.mascot = "Mascot is required.";
      }

      if (!Object.keys(this.errors).length) {
        return true;
      }

      if (withToast) {
        this.$store.dispatch("showToast", {
          txt: "Please verify your information is correct",
          type: "error",
        });
      }
      return false;
    },

    save() {
      if (this.checkForm()) {
        let params = {
          id: this.projectId,
          title: this.name,
          team_name: this.mascot,
          _method: "put",
        };

        if (Number(this.selected_rep_id)) {
          params.rep = this.selected_rep_id;
          params.rep_id = this.selected_rep_id;
        } else {
          params.rep = null;
        }

        if (this.overridePricing) {
          params.overridePricing = this.overridePricing;
          params.display_msrp = this.display_msrp;
          params.complimentary_msg = this.complimentary_msg;
        }

        let url = "";

        switch (this.projectTypeToBeEdited) {
          case "showroom":
            url = this.$store.state.settings.endpoint + "api/v2/team-link";
            break;
          case "snapsheet":
            url =
              this.$store.state.settings.endpoint +
              "api/snapsheets/" +
              this.project.id;
            break;

          default:
            url = this.$store.state.settings.endpoint + "api/v2/team-link";
            break;
        }

        if (this.checkForm()) {
          axios
            .put(url, params, {
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + this.auth.apiToken,
              },
            })
            .then((response) => {
              this.$store.dispatch("showToast", {
                txt: 'Edited successfully"',
              });

              this.$emit("updateProjectData", response.data);
              this.$emit("editEvent", "save");
            })
            .catch((e) => {
              this.$store.dispatch("showToast", {
                txt: e,
                type: "error",
              });
            });
        }
      }
    },

    saveEditedLogo({ editedLogo, typeOfLogo }) {
      this.editableLogo.fileUploaded = editedLogo;
      this.editableLogo.typeOfLogo = typeOfLogo;
    },

    updateLogoData({ colors, typeOfLogo }) {
      this.editableLogo.colors = colors;
      this.editableLogo.typeOfLogo = typeOfLogo;
    },

    updateLogoStatus({ status }) {
      this.editableLogo.status = status;
    },

    openEditLogoModal(logo) {
      this.editableLogo = logo;
    },

    openCreateSalesRepModal(mode, rep) {
      switch (mode) {
        case 0: {
          this.triggerEditModal(0, null);
          break;
        }
        case 1: {
          this.modal_errors = {};
          this.triggerEditModal(mode, rep);
          break;
        }
        case 2: {
          this.removeRep(rep);
          break;
        }
      }
    },

    triggerEditModal(mode, user) {
      this.modalMode = mode;
      this.modalName = user ? user.name : "";
      this.modalEmail = user ? user.email : "";
      this.modalPhone = user ? user.phone : "";
      this.modalUserId = user ? user.id : 0;
    },

    postModal(data) {
      let params = {
        name: data.modalName,
        email: data.modalEmail,
        phone: data.modalPhone,
        _method: "post",
      };

      //Edit Rep
      if (data.modalUserId) {
        params.user_id = data.modalUserId;
        params._method = "put";
        this.editSalesRep(params); //.then(this.$emit("getAllReps"));
      } else {
        //Add new Rep
        this.addNewSalesRep(params); //.then(this.$emit("getAllReps"));
      }
    },
  },
};
</script>

<style lang="scss" scoped>
div#edit-team-link {
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.8);
  height: 100vh;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  ::v-deep .modal-dialog {
    margin-top: 120px;
  }
  .edit-team-container {
    background-color: white;
    width: 100%;
    max-width: 930px;
    padding: 20px;
    .edit-team-content {
      margin-top: 20px;
      .v-select {
        &::v-deep .vs__search,
        &::v-deep .vs__selected {
          height: 29px;
        }
      }
      .rep-information {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin: 30px 30px 0 30px;
        .rep-title {
          display: flex;
          flex-direction: column;
          align-items: center;
          small {
            font-size: 14px;
          }
        }
      }
    }
  }
  .wiz-submit-container {
    width: 100%;
    display: flex;
    justify-content: center;
    margin: 20px 0;
    button {
      margin: 0 5px;
    }
  }
}
</style>